<template>
    <custom-select ref="vselect"
                :options="selectOptions"
                :on-change="onChange"
                :clearSearchOnSelect="true"
                :value="selectedOption"
                :loading="loading"
                :disabled="disabled"
                :selectOnTab="true">
    </custom-select>
</template>

<script>
    import Vue from "vue";
    import vSelect from 'vue-select';
    import axios from 'axios';

    Vue.component('v-select', vSelect);

    Vue.component('custom-select', {
        extends: vSelect,
        methods: {
            maybeAdjustScroll: () => false
        }
    })

    export default {
        data: function () {
            return {
                selectedOption: null,
                selectOptions: [],
                loading: false,
            };
        },
        components: { vSelect },
        props: {
            value: String,
            disabled: Boolean,
            isOutlook: Boolean
        },
        methods: {
            // called when an item is selected
            onChange(item) {
                if (item !== null) {
                    this.$emit('input', item.value);
                } else {
                    this.$emit('input', null);
                }
            },
        },
        // fetches list of users when the component is created.
        created() {
            var url = "/core/api";
            var authHeader = "";
            this.loading = true;
            if (this.isOutlook) {
                url = this.$store.state.keaUrl + url + "/users/active";
                authHeader = { headers: { "Authorization": "Bearer " + this.$store.state.accessToken } };
            } else  {
                url += "/users/active";
            }
            axios.get(url, authHeader)
                .then(response => {
                    var users = response.data;
                    var self = this;
                    users.forEach(function (u) {
                        var option = { label: u.name, value: u.initials };
                        self.selectOptions.push(option);
                        if (u.initials == self.value) {
                            self.selectedOption = option;
                        }
                    });
                    this.loading = false;
                })
        }
    };
</script>

<style lang="scss">
    @use "vselect-styles.scss";
</style>
